import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { SignMethodStat } from "../../../../types/onboardingAnalytics";
import { SignMethod } from "../../../../types/onboarding";
import { signMethodLabel } from "../../../../constants/contractSigning";
import {
  formatCount,
  formatDays,
  humaniseSegment,
} from "../../../../utils/analyticsFormat";

interface SignMethodPanelProps {
  methods: SignMethodStat[];
}

const KNOWN_METHODS: SignMethod[] = ["MANUAL", "DIGITAL", "CLICK_TO_SIGN"];

/**
 * How long each signing route takes, from contract sent to contract signed.
 *
 * Every average is shown with the count behind it (FR-024). Without that, one
 * prospect who signed in an hour makes a method look like the fastest route
 * available, and someone will act on it.
 */
const SignMethodPanel: React.FC<SignMethodPanelProps> = ({ methods }) => {
  const methodBody = (stat: SignMethodStat) =>
    KNOWN_METHODS.includes(stat.method as SignMethod)
      ? signMethodLabel(stat.method as SignMethod)
      : humaniseSegment(String(stat.method));

  const avgBody = (stat: SignMethodStat) =>
    formatDays(stat.avgDays, stat.count) ?? (
      <span className="text-500">No data yet</span>
    );

  const countBody = (stat: SignMethodStat) => formatCount(stat.count);

  return (
    <DataTable
      value={methods}
      dataKey="method"
      className="p-datatable-sm"
      aria-label="Time to sign by method"
    >
      <Column header="Method" body={methodBody} />
      <Column header="Average to sign" body={avgBody} style={{ width: "11rem" }} />
      <Column header="Contracts" body={countBody} style={{ width: "8rem" }} />
    </DataTable>
  );
};

export default SignMethodPanel;
